// Focus outlines for keyboard users only.
//
// Browsers treat some mouse clicks and taps as ":focus-visible" (text fields, focus moved by a
// script after a click, Radix menus returning focus to their trigger), so a click can still draw
// a focus ring. This records how the visitor is interacting on <html data-input="pointer|keyboard">;
// accessibility.css removes every focus outline and ring while it is "pointer". Tabbing or using
// the arrow keys switches back to "keyboard", so keyboard users keep their focus indicator.

const KEYBOARD_NAV_KEYS = new Set([
  "Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End", "PageUp", "PageDown", "F6",
]);

let installed = false;

export function installInputModality() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  const root = document.documentElement;
  const set = (mode) => {
    if (root.dataset.input !== mode) root.dataset.input = mode;
  };
  window.addEventListener("pointerdown", () => set("pointer"), true);
  window.addEventListener(
    "keydown",
    (event) => {
      if (KEYBOARD_NAV_KEYS.has(event.key)) set("keyboard");
    },
    true,
  );
}
